import React from 'react';
import { View, Text, TextStyle, StyleProp } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper, { WithColor } from '@styles/colors';
import TouchableElement from '@components/common/touchableElement';

import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';

import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { STATUS } from './constants';
import { useManageSendToImnooButton } from './hooks/useManageSendToImnooButton';

export interface SendToImnooButtonProps extends WithColor {
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const SendToImnooButton: React.FC<SendToImnooButtonProps> = ({ font = initialFont, scale = initialScale, C }) => {
  const { status, timestamp, onPress } = useManageSendToImnooButton();

  const fontStyle: StyleProp<TextStyle> = [font['Button 2'], { fontWeight: 500 }];

  switch (status) {
    case STATUS.ACTIVE:
      return (
        <TouchableElement onPress={onPress}>
          {({ boxStyle, pressHoverColor }) => {
            return (
              <View
                style={[
                  boxStyle,
                  {
                    borderRadius: scale(14.5),
                    paddingHorizontal: scale(13),
                    paddingVertical: scale(6.5),
                    backgroundColor: C(pressHoverColor('Button/Light/Secondary')),
                    outline: 'none',
                  },
                ]}
              >
                <Text style={[fontStyle, { color: C('Button/Light/Secondary Text') }]}>{i18n.t('Send to Imnoo')}</Text>
              </View>
            );
          }}
        </TouchableElement>
      );
    case STATUS.PENDING:
      return (
        <Text
          style={[
            fontStyle,
            {
              color: C('Label/Light/Quinary'),
              paddingHorizontal: scale(13),
              paddingVertical: scale(6.5),
            },
          ]}
        >
          {i18n.t('Sending...')}
        </Text>
      );
    case STATUS.FINISHED:
      return (
        <Text
          style={[
            fontStyle,
            {
              color: C('Label/Light/Quinary'),
              paddingHorizontal: scale(13),
              paddingVertical: scale(6.5),
            },
          ]}
        >
          {i18n.t('Sent to Imnoo') + ' ' + timestamp.current}
        </Text>
      );
    default:
      return null;
  }
};

export default ColorWrapper(SendToImnooButton);
